// Local translations
export const T = {
  en_GB: {
    edit: "Edit",
    productCostTypes: "Product Costs",
    description:
      "Configure cost types to track for products in this collection. Each cost type maps to one or more API fields with priority fallback.",
    addCostType: "Add Cost Type",
    noCostTypes: 'No cost types configured. Click "Add Cost Type" to create one.',
    name: "Name",
    category: "Category",
    mappedApiKeys: "Mapped API Keys",
    actions: "Actions",
    noKeysConfigured: "No keys configured",
    deleteCostType: "Delete Cost Type",
    deleteConfirmation:
      "Are you sure you want to delete this cost type? This action cannot be undone.",
    delete: "Delete",
    cancel: "Cancel",
    costTypeDeleted: "Cost type deleted successfully",
    error: "Error",
    failedToDelete: "Failed to delete cost type",
    categoryRecurring: "Recurring",
    categoryDeposit: "Deposit",
    categoryWithdrawal: "Withdrawal",
    more: "more",
  },
  nb_NO: {
    edit: "Rediger",
    productCostTypes: "Produktkostnader",
    description:
      "Konfigurer kostnadstyper som skal spores for produkter i denne samlingen. Hver kostnadstype kobles til ett eller flere API-felt med prioritert fallback.",
    addCostType: "Legg til kostnadstype",
    noCostTypes:
      'Ingen kostnadstyper konfigurert. Klikk "Legg til kostnadstype" for å opprette en.',
    name: "Navn",
    category: "Kategori",
    mappedApiKeys: "Tilknyttede API-nøkler",
    actions: "Handlinger",
    noKeysConfigured: "Ingen nøkler konfigurert",
    deleteCostType: "Slett kostnadstype",
    deleteConfirmation:
      "Er du sikker på at du vil slette denne kostnadstypen? Denne handlingen kan ikke angres.",
    delete: "Slett",
    cancel: "Avbryt",
    costTypeDeleted: "Kostnadstype slettet",
    error: "Feil",
    failedToDelete: "Kunne ikke slette kostnadstype",
    categoryRecurring: "Løpende",
    categoryDeposit: "Innskudd",
    categoryWithdrawal: "Uttak",
    more: "flere",
  },
} as const;
